import axios, { AxiosError } from "axios";
import { ChangeEvent, FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateMagasinEnligneMobile from "../../Views/Register/CreateMagasinEnligneMobile";

export default function AddMagasinenligneMobile() {
  const navigate = useNavigate();
  const [NomMagasin, setNomMagasin] = useState<string>("");
  const [Latitude, setLatitude] = useState<any>(0);
  const [Longitude, setLongitude] = useState<any>(0);
  const [nom, setnom] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [password, setpassword] = useState<string>("");
  const [tele, settele] = useState<string>("");
  const [adresse, setAdresse] = useState<string>("");
  const [messageError, setMessageError] = useState<string>("");
  const [messageSucess, setMessageSucess] = useState<string>("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("NomMagasin", NomMagasin);
    formData.append("nom", nom);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("tele", tele);
    formData.append("latitude", String(Latitude));
    formData.append("longitude", String(Longitude));
    formData.append("adress", adresse); // Make sure this matches what your API expects

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/magasin-enligne/create`,
        formData
      );
      setMessageSucess(
        "Votre commande est en cours de traitement et vous en serez informé par e-mail"
      );
      const timeoutId = setTimeout(() => {
        setMessageSucess("");
      }, 4000);

      // Optionally redirect or clear form after success
      // navigate('/success-page');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Get the specific error from the API if available
        const errorMessage =
          error.response.data.message ||
          "Veuillez saisir toutes les informations correctement";
        setMessageError(errorMessage);
      } else {
        setMessageError("Une erreur s'est produite. Veuillez réessayer.");
      }

      const timeoutId = setTimeout(() => {
        setMessageError("");
      }, 3000);
    }
  };
  return (
    <>
      <CreateMagasinEnligneMobile
        setAdress={setAdresse}
        adress={adresse}
        setNomMagasin={setNomMagasin}
        setnom={setnom}
        setemail={setemail}
        setpassword={setpassword}
        settele={settele}
        setMessageError={setMessageError}
        setMessageSucess={setMessageSucess}
        handleSubmit={handleSubmit}
        setLatitude={setLatitude}
        setLongitude={setLongitude}
        Latitude={Latitude}
        Longitude={Longitude}
        messageError={messageError}
        messageSucess={messageSucess}
        NomMagasin={NomMagasin}
        nom={nom}
        email={email}
        password={password}
        tele={tele}
      />
    </>
  );
}
